import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar';
import AuthNavbar from '../components/common/AuthNavbar';

const DashboardLayout = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
   
      navigate('/login', { replace: true });
    }
  }, [navigate]);

  const token = localStorage.getItem('adminToken');
  if (!token) return null; 

  return (
    <React.Fragment>
      {/* Optional: Show navbar if needed */}
      {/* <AuthNavbar /> */}
      <div style={{ display: 'flex' }}>
        <Sidebar />
        <main className='lg:w-[80%] w-[100%] h-[100vh] overflow-y-scroll'>
          {children}
        </main>
      </div>
    </React.Fragment>
  );
};

export default DashboardLayout;

